var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { map } from 'lit/directives/map.js';
import { DateTime } from 'luxon';
import { TagadaStatusEnum, } from '@sgdf/client';
import { classMap } from 'lit/directives/class-map.js';
import { when } from 'lit/directives/when.js';
import { SgdfElement } from '../../internal/sgdf-element';
import { emit } from '../../internal/event';
import styles from './meeting-gestionnaire-table.styles';
import '../../atoms/table/sgdf-table.js';
import '../../atoms/button/button.js';
import '../../atoms/icon/icon.js';
import '../../atoms/tag/tag.js';
import '@shoelace-style/shoelace/dist/components/switch/switch.js';
import '@shoelace-style/shoelace/dist/components/select/select.js';
const SKELETON_MEETINGS = [
    {
        id: '',
        label: '-',
        created_at: new Date('2022-02-02T20:35:56.575249Z'),
        end_date: new Date('2021-09-30T00:00:00Z'),
        meeting_type_id: null,
        meeting_type: {
            id: '',
            label: '-',
            modules_default: [],
        },
        place_id: null,
        place: {
            id: '5fbb366e-7501-495f-b7aa-6ac8f3a748cc',
            label: '-',
            address: '-',
            zipcode: '59000',
            city: '??????',
        },
        start_date: new Date('2021-09-30T00:00:00Z'),
        structure_organisatrice_id: null,
        structure_organisatrice: {
            structure_code: 'test',
            id: '',
            label: '-',
        },
        updated_at: new Date('2022-04-02T09:20:52.287600Z'),
        code_analytic: '',
        supervisors: [],
        intranet_id: '7613',
        num_agreement_js: '',
        status: 'open',
        modules: [],
        tracks: [],
        daytime_min: '07:00',
        daytime_max: '23:30',
        tagada_status: TagadaStatusEnum.Untested,
        tagada_password: 'password',
        tagada_participants_last_sync: new Date('2021-09-30T00:00:00Z'),
        tagada_avis_last_sync: new Date('2021-09-30T00:00:00Z'),
        tagada_total_candidates: 40,
        tagada_synced_candidates: 20,
        has_opinions: true,
        ndays: 1,
    },
];
const statusMap = {
    open: 'ouvert',
    committed: 'clôturé',
    close: 'fermé',
    cancelled: 'annulé',
    request_to_anonymize: 'prêt à anonymiser',
    anonymized: 'anonymisé',
};
const opinionStatusMap = {
    not_started: 'Avis: Non commencé',
    in_progress: 'Avis: En cours',
    validated_director: 'Avis: Validé directeur·ice',
    validated_orga: 'Avis: Validé OF',
    submitted: 'Avis: Soumis J&S',
    manually_submitted: 'Avis: Soumis J&S - Manuel',
};
export const getFormattedMeeting = (meeting) => {
    var _a, _b, _c;
    return ({
        id: meeting.id,
        name: meeting.label,
        type: (_a = meeting.meeting_type) === null || _a === void 0 ? void 0 : _a.label,
        place: (_b = meeting.place) === null || _b === void 0 ? void 0 : _b.label,
        period: `Du ${new Date(meeting.start_date).toLocaleDateString('fr-FR')} au ${new Date(meeting.end_date).toLocaleDateString('fr-FR')}`,
        structure: (_c = meeting.structure_organisatrice) === null || _c === void 0 ? void 0 : _c.label,
        status: meeting.status,
        formatted_status: meeting.status
            ? statusMap[meeting.status]
            : meeting.status,
        opinion_status: meeting.opinion_status
            ? opinionStatusMap[meeting.opinion_status]
            : undefined,
        has_opinions: meeting.has_opinions,
    });
};
export const headers = [
    { title: 'Nom du stage', field_name: 'name' },
    { title: 'Type', field_name: 'type' },
    { title: 'Période', field_name: 'period' },
    { title: 'Lieu', field_name: 'place' },
    { title: 'Etat', field_name: 'formatted_status' },
];
/**
 *  @status in-work
 */
let SgdfMeetingGestionnaireTable = class SgdfMeetingGestionnaireTable extends SgdfElement {
    constructor() {
        super(...arguments);
        this.skeleton = false;
        this.scopeOnly = false;
        this.meetingCount = 0;
        this.centreRessources = [];
        this.meetingTypes = [];
        this.withHasOpinion = false;
        this.includePastYears = false;
        this.page = 1;
        this.pageSize = 10;
        this.hasNextPage = () => this.meetingCount && this.meetingCount > this.page * this.pageSize;
    }
    onResize({ width }) {
        this._width = width;
    }
    connectedCallback() {
        this.onTableClick = this.onTableClick.bind(this);
        super.connectedCallback();
        addEventListener('sgdf-table:click', this.onTableClick);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    async onTableClick(event) {
        const { detail } = event;
        event.stopPropagation();
        this.emit('sgdf-meeting-table:click', { detail });
    }
    async onCardClick(index) {
        this.emit('sgdf-meeting-table:click', {
            detail: this.meetings[index],
        });
    }
    async onCardSync(index) {
        emit(this, 'sgdf-meeting-table:sync', {
            detail: this.meetings[index],
        });
    }
    async onCardManage(index) {
        this.emit('sgdf-meeting-table:manage', {
            detail: this.meetings[index],
        });
    }
    async onCardRequestAnonymize(index) {
        this.emit('sgdf-meeting-table:requestanonymize', {
            detail: this.meetings[index],
        });
    }
    async onCardCancelRequestAnonymize(index) {
        this.emit('sgdf-meeting-table:cancelrequestanonymize', {
            detail: this.meetings[index],
        });
    }
    async onExportPvClick() {
        this.emit('sgdf-participants-pv:export', {
            detail: {
                centreRessourceId: this.currentCentreRessourceUuid,
                meetingTypeIds: this.currentMeetingTypesUuid,
                startDate: this.startDate,
                endDate: this.endDate,
                opinionStatus: this.opinionStatus,
                withHasOpinion: this.withHasOpinion,
                includePastYears: this.includePastYears,
                meetingStatus: this.meetingStatus,
            },
        });
    }
    onChangeFilter() {
        this.emit('sgdf-structure-participants:filter', {
            detail: {
                centreRessourceId: this.currentCentreRessourceUuid,
                meetingTypeIds: this.currentMeetingTypesUuid,
                startDate: this.startDate,
                endDate: this.endDate,
                opinionStatus: this.opinionStatus,
                withHasOpinion: this.withHasOpinion,
                includePastYears: this.includePastYears,
                meetingStatus: this.meetingStatus,
            },
        });
    }
    render() {
        // NOTE: This value is arbitrary, we don't have a better solution for now
        // It's a bit more than the width of the table in french (which is the largest) and with both links (download and pay)
        // The table width is mostly stable since the with of the amount is fixed and the rest is almost always the same number of characters
        const bigMode = this._width && this._width > 700;
        const skeleton = this.skeleton || this.meetings == null;
        const meetings = skeleton ? SKELETON_MEETINGS : this.meetings;
        const formattedMeeting = meetings.map(meeting => getFormattedMeeting(meeting));
        return bigMode
            ? this._renderBig(formattedMeeting)
            : this._renderSmall(skeleton, formattedMeeting);
    }
    _renderBig(formattedMeeting) {
        return html `
            <sgdf-table
                .columns=${headers}
                .data=${formattedMeeting}
                .tableWidth=${this._width}
                .noDataMessage=${'Aucun stage disponible'}
            >
            </sgdf-table>
        `;
    }
    _renderSmall(skeleton, meetingList) {
        var _a, _b, _c, _d, _e, _f;
        return html `
            <div class="filter-list">
                <sl-select
                    class="filter struct-orga-filter"
                    label="Structure Organisatrice"
                    name="centre_ressource"
                    clearable
                    @sl-change=${(e) => {
            var _a;
            this.currentCentreRessourceUuid =
                e.currentTarget.value.length == 0
                    ? undefined
                    : ((_a = e.currentTarget.value) !== null && _a !== void 0 ? _a : undefined);
            this.onChangeFilter();
        }}
                    value=${this.currentCentreRessourceUuid}
                >
                    ${map(this.centreRessources, structure => html `
                            <sl-option value="${structure.id}"
                                >${structure.label}</sl-option
                            >
                        `)}
                </sl-select>
                <sl-select
                    class="filter select-filter"
                    label="Type de formation"
                    name="meeting_type"
                    multiple
                    clearable
                    @sl-change=${(e) => {
            this.currentMeetingTypesUuid =
                e.currentTarget.value.length === 0
                    ? undefined
                    : e.currentTarget.value;
            this.onChangeFilter();
        }}
                    value=${(_b = (_a = this.currentMeetingTypesUuid) === null || _a === void 0 ? void 0 : _a.join(' ')) !== null && _b !== void 0 ? _b : ''}
                >
                    ${map(this.meetingTypes, meetingType => html `
                            <sl-option value="${meetingType.id}"
                                >${meetingType.label}</sl-option
                            >
                        `)}
                </sl-select>
                <sl-input
                    class="filter"
                    type="date"
                    name="start_date"
                    label="Début de la période"
                    @sl-change=${(e) => {
            this.startDate =
                e.target.value === ''
                    ? undefined
                    : DateTime.fromISO(e.target.value).toJSDate();
            this.onChangeFilter();
        }}
                    value=${this.startDate
            ? typeof this.startDate === 'string'
                ? this.startDate.split('T')[0]
                : DateTime.fromJSDate(this.startDate).toISODate()
            : undefined}
                >
                </sl-input>
                <sl-input
                    class="filter"
                    type="date"
                    name="end_date"
                    label="Fin de la période"
                    @sl-change=${(e) => {
            this.endDate =
                e.target.value === ''
                    ? undefined
                    : DateTime.fromISO(e.target.value).toJSDate();
            this.onChangeFilter();
        }}
                    value=${this.endDate
            ? typeof this.endDate === 'string'
                ? this.endDate.split('T')[0]
                : DateTime.fromJSDate(this.endDate).toISODate()
            : undefined}
                >
                </sl-input>
                <sl-select
                    class="filter select-filter"
                    label="Statut des avis"
                    name="opinion_status"
                    multiple
                    clearable
                    @sl-change=${(e) => {
            this.opinionStatus =
                e.currentTarget.value.length === 0
                    ? undefined
                    : e.currentTarget.value;
            this.onChangeFilter();
        }}
                    value=${(_d = (_c = this.opinionStatus) === null || _c === void 0 ? void 0 : _c.join(' ')) !== null && _d !== void 0 ? _d : ''}
                    ><sl-option value="not_started">Non commencé</sl-option
                    ><sl-option value="in_progress"
                        >Rédaction en cours</sl-option
                    ><sl-option value="validated_director"
                        >Valider par directeur·ice</sl-option
                    ><sl-option value="validated_orga"
                        >Validé national</sl-option
                    ><sl-option value="submitted"
                        >Finalisé - Soumis J&S</sl-option
                    >
                </sl-select>
                <sl-select
                    class="filter select-filter"
                    label="Statut du stage"
                    name="meeting_status"
                    multiple
                    clearable
                    @sl-change=${(e) => {
            this.meetingStatus =
                e.currentTarget.value.length === 0
                    ? undefined
                    : e.currentTarget.value;
            this.onChangeFilter();
        }}
                    value=${(_f = (_e = this.meetingStatus) === null || _e === void 0 ? void 0 : _e.join(' ')) !== null && _f !== void 0 ? _f : ''}
                    >${Object.keys(statusMap).map((s) => html `<sl-option value="${s}">${statusMap[s]}</sl-option>`)}
                </sl-select>
                <sl-switch
                    class="filter"
                    name="withHasOpinion"
                    .checked=${this.withHasOpinion}
                    @sl-change=${(e) => {
            this.withHasOpinion = !this.withHasOpinion;
            this.onChangeFilter();
        }}
                    >Stage long seulement</sl-switch
                >
                <sl-switch
                    class="filter"
                    name="includePastYears"
                    .checked=${!this.includePastYears}
                    @sl-change=${(e) => {
            this.includePastYears = !this.includePastYears;
            this.onChangeFilter();
        }}
                    >Cacher saisons précédentes</sl-switch
                >
                ${when(!this.scopeOnly, () => html `<sgdf-button
                            class="filter"
                            @click=${() => this.onExportPvClick()}
                            >Export PV général</sgdf-button
                        >`)}
            </div>

            <div class="meeting-list">
                ${meetingList.map((meeting, i) => html `
                        <div class="card" @click=${() => this.onCardClick(i)}>
                            <div class="card-body">
                                <h5
                                    class="card-title ${classMap({ skeleton })}"
                                >
                                    ${meeting.name}
                                    ${meeting.status == 'open'
            ? html `<sgdf-tag success
                                              >${meeting.formatted_status}</sgdf-tag
                                          >`
            : html `<sgdf-tag warning
                                              >${meeting.formatted_status}</sgdf-tag
                                          >`}
                                    ${when(meeting.has_opinions, () => html ` <sgdf-tag primary
                                                >${meeting.opinion_status}</sgdf-tag
                                            >`)}
                                </h5>
                                ${meeting.type
            ? html `<span
                                          class="${classMap({ skeleton })}"
                                          ><sgdf-meeting-type
                                              .name=${meeting.type}
                                          ></sgdf-meeting-type>
                                      </span>`
            : null}
                                <span
                                    class="${classMap({ skeleton })}"
                                    aria-label="Lieu"
                                    ><sgdf-icon
                                        library="picto"
                                        name="signesCommuns-Tente"
                                    ></sgdf-icon
                                    >${meeting.place}<br
                                /></span>
                                <sgdf-icon name="calendar"></sgdf-icon
                                >${meeting.period}<br />
                                <span
                                    class="${classMap({ skeleton })}"
                                    aria-label="Structure Organisatrice"
                                    ><sgdf-icon name="user-group"></sgdf-icon
                                    >${meeting.structure}<br
                                /></span>

                                <sgdf-button @click=${() => this.onCardSync(i)}>
                                    <sgdf-icon
                                        slot="suffix"
                                        name="rotate"
                                    ></sgdf-icon
                                    >Synchroniser depuis intranet
                                </sgdf-button>
                                <sgdf-button
                                    @click=${() => this.onCardManage(i)}
                                >
                                    <sgdf-icon
                                        slot="suffix"
                                        name="gear"
                                    ></sgdf-icon
                                    >Gérer le stage
                                </sgdf-button>
                                ${meeting.status == 'close'
            ? html ` <sgdf-button
                                          @click=${() => this.onCardRequestAnonymize(i)}
                                      >
                                          <sgdf-icon
                                              slot="suffix"
                                              name="box-archive"
                                          ></sgdf-icon
                                          >Demander l'anonymisation
                                      </sgdf-button>`
            : null}
                                ${meeting.status == 'request_to_anonymize'
            ? html ` <sgdf-button
                                          @click=${() => this.onCardCancelRequestAnonymize(i)}
                                      >
                                          <sgdf-icon
                                              slot="suffix"
                                              name="tree"
                                          ></sgdf-icon
                                          >Annuler la mise en anonymisation
                                      </sgdf-button>`
            : null}
                            </div>
                        </div>
                    `)}
            </div>

            <div class="page-panel">
                <div class="page-panel-left">
                    <div>
                        Page ${this.meetingCount === 0 ? 0 : this.page} /
                        ${Math.ceil(this.meetingCount / this.pageSize)}
                    </div>
                    <sl-select
                        class="page-size-select"
                        value=${this.pageSize}
                        id="pageSize"
                        name="pageSize"
                        @sl-change="${(e) => {
            this.pageSize = e.currentTarget.value;
            this.emit('sgdf-page-size:change', {
                detail: {
                    pageSize: this.pageSize,
                },
            });
        }}"
                    >
                        <sl-option value="10">10</sl-option>
                        <sl-option value="20">20</sl-option>
                        <sl-option value="50">50</sl-option>
                        <sl-option value="100">100</sl-option>
                    </sl-select>
                </div>
                <div class="page-panel-right">
                    <sgdf-button
                        @click=${() => {
            this.emit('sgdf-page:prev');
        }}
                        ?disabled=${this.page === 1}
                        >Précédent</sgdf-button
                    >
                    <sgdf-button
                        @click=${() => {
            this.emit('sgdf-page:next');
        }}
                        ?disabled=${!this.hasNextPage()}
                        >Suivant</sgdf-button
                    >
                </div>
            </div>
        `;
    }
};
SgdfMeetingGestionnaireTable.styles = styles;
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "skeleton", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "meetings", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "scopeOnly", void 0);
__decorate([
    property({ type: Number, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "meetingCount", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "centreRessources", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "meetingTypes", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "currentCentreRessourceUuid", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "currentMeetingTypesUuid", void 0);
__decorate([
    property({ type: Date, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "startDate", void 0);
__decorate([
    property({ type: Date, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "endDate", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "withHasOpinion", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "includePastYears", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "opinionStatus", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "meetingStatus", void 0);
__decorate([
    property({ type: Number, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "page", void 0);
__decorate([
    property({ type: Number, reflect: true })
], SgdfMeetingGestionnaireTable.prototype, "pageSize", void 0);
SgdfMeetingGestionnaireTable = __decorate([
    customElement('sgdf-meeting-gestionnaire-table')
], SgdfMeetingGestionnaireTable);
export default SgdfMeetingGestionnaireTable;
//# sourceMappingURL=meeting-gestionnaire-table.js.map